<template>
  <CSidebar
    aside
    :show="$store.state.asideShow"
    @update:show="(val) => $store.commit('set', ['asideShow', val])"
    unfoldable
    breakpoint="sm"
    size="lg"
  >
    <CSidebarClose @click.native="$store.commit('toggle', 'asideShow')"/>
    <CTabs tabs class="nav-underline nav-underline-info">
      <CTab active>
        <template slot="title">
          <CIcon name="cilBellExclamation" class="mr-1"/> <b>경보</b>
        </template>

        <AlarmAlertList/>
      </CTab>

      <CTab>
        <template slot="title">
          <CIcon name="cil-cog" class="mr-1"/> <b>설정</b>
        </template>

        <AlarmConfigList :received="evtReceived"
                         announce
                         @change-days="onChangeDays"
                         @select-code="delayEvtCode = $event"/>

        <AlarmDelayPanel class="mt-1" :evt-code="delayEvtCode"/>
      </CTab>
    </CTabs>
  </CSidebar>

</template>

<script>
import moment from "moment";
import {
  apiCall, beepSound, speech, sleep, getDiffSeconds, loadSuppressAlarms
} from '@/common/utils';
import qs from 'querystring';
import AlarmAlertList from '@/views/components/alarm/AlarmAlertList';
import AlarmConfigList from '@/views/components/alarm/AlarmConfigList';
import AlarmDelayPanel from '@/views/components/alarm/AlarmDelayPanel';


export default {
  name: 'TheAside',
  components: {
    AlarmAlertList,
    AlarmConfigList,
    AlarmDelayPanel,
  },
  data () {
    return {
      isReady: false,
      evtReceived: {},
      evtLatest: {}, // {code: {tid: {dt, toasted}}}
      delayEvtCode: '1',
      suppressInterval: null,
      fromDays: 3,
      eventCodeMap: null,
      tankMap: null,
      alarmCfg: this.$store.state.alarm,
      socket: this.$store.state.socket,
    }
  },
  computed: {
    // 경보 목록/알람지연 정보는 스토어에서 경보현황 화면과 공유한다.
    alerts(){
      return this.$store.state.alarm.alerts;
    },
    suppressAlarms(){
      return this.$store.state.alarm.suppress;
    },
  },
  async mounted() {
    try{

      await sleep(1000);
      this.eventCodeMap = this.$store.state.codeMaps['EVENT'];
      this.tankMap = this.$store.state.tanks['map'];

      this.fromDays = this.$store.state.alarm.count.fromDays? this.$store.state.alarm.count.fromDays:3;

      this.setEvtLatestByTid();

      // 경보 필터링(isAlarmSuppressed)에 쓰이므로 지연정보는 여기서 주기 적재한다.
      await loadSuppressAlarms();
      this.suppressInterval = setInterval( async ()=>{ await loadSuppressAlarms() }, 1000 * 60);

      // 접속 전에 발생한 경보를 먼저 채운다. 이후 소켓 경보가 위에 쌓인다.
      await this.getRecentAlerts();

      // 사운드 설정은 로그인 후 한 번만 묻는다. 이미 고른 값(localStorage.soundOn)이 있으면
      // 새로고침해도 다시 묻지 않고 그 값을 쓴다. 취소해도 '0' 으로 기록해 반복해서 묻지 않는다.
      if( localStorage.getItem('soundOn') === null ){
        if( await this.confirmModal('브라우저 사운드 설정이 Off 입니다. 사운드 설정을 On 합니다.') ){
          this.$store.commit('toggle', 'soundOn');
        }else{
          try { localStorage.soundOn = '0'; } catch (e) { /* 저장 불가 환경은 무시 */ }
        }
      }

      if( !this.socket ) await sleep(3000);
      this.socket = this.$store.state.socket;

      if(this.socket) {
        console.warn("\n\n\n\n[TheAside] ---------------- register eventAlarmHandler #########");
        this.socket.removeListener('event', this.eventAlarmHandler)
        this.socket.on('event', this.eventAlarmHandler); // { tid, tnm, cmd, dt, payload }

        console.warn( "\n\n\n\n[TheAside] ---------------- socket object ------> is connecting? ", this.socket.connected );
        this.isReady = true;
      }else{
        console.warn("\n\n\n\n[TheAside] ---------------- socket not found ---------------\n\n\n\n\n");
        this.isReady = false;
        alert("경보알람 수신이 불가 합니다. 재 로그인 바랍니다.\n지속적인 수신불가시 관리자 문의 바랍니다");
      }

    }catch(err){
      console.error(err);
    }


  },
  methods: {
    /** 설정 탭에서 조회기간이 바뀌면 경보 목록도 같은 기간으로 다시 채운다 */
    async onChangeDays(fromDays){
      this.fromDays = fromDays;
      await this.getRecentAlerts();
    },

    eventAlarmHandler(data){
      // data = { tid, tnm=tankName, cmd, dt, payload }
      const {payload} = data;
      if(payload.length) {
        payload.map( e => {
          // 다음 알람 시간정보 구성
          this.$store.state.alarm.count[e.code]++;
          this.$store.state.alarm.count['total']++;

          // 키가 미리 없을 수 있어 $set 으로 반응형 등록 (설정 탭 수신 스피너)
          this.$set(this.evtReceived, e.code, true);
          setTimeout(()=>{ this.$set(this.evtReceived, e.code, false) }, 2000);

          const latest = this.evtLatest[e.code][e.tid];
          if( getDiffSeconds(latest?.dt) > 60 ) latest.toasted = false;

          if( !this.isAlarmSuppressed(e.code, e.tid) ) {
            this.consoleAlarm(e);
          }

        })
      }
    },

    /**
     * 접속 전에 발생한 경보를 목록에 채운다.
     *
     * 소켓 경보는 접속 이후 발생분만 오므로, 로그인 직후에는 목록이 비어 있었다.
     * 서버가 (탱크, 경보)별 마지막 1건만 최근순으로 내려주므로 같은 경보가
     * 반복된 탱크 때문에 목록이 묻히지 않는다.
     */
    async getRecentAlerts(){
      try{
        const query = qs.stringify({
          fromDts: moment().subtract(this.fromDays, 'days').toISOString(),
          toDts  : moment().toISOString(),
        });

        const {result} = await apiCall('get', `/api/event/latest?${query}`);
        if(!result) return;

        // 화면 표시에 필요한 탱크명은 서버가 주지 않으므로 여기서 붙인다
        this.alerts.splice(0, this.alerts.length,
          ...result.map( e => ({...e, tnm: this.tankMap?.[e.tid]?.name || e.tid}) ));

        // 같은 탱크·경보가 소켓으로 다시 오면 새 알림으로 뜨도록 최종 발생시각을 맞춰둔다.
        // (60초 이내 재발생은 중복으로 보고 걸러진다 - eventAlarmHandler)
        result.forEach( e => {
          if( this.evtLatest[e.code] && this.evtLatest[e.code][e.tid] ){
            this.evtLatest[e.code][e.tid] = { dt: e.dt, toasted: true };
          }
        });

      }catch(err){
        console.error(err);
      }
    },

    setEvtLatestByTid(){
      // 탱크별 최종 이벤트 코드 저장
      for(const code in this.eventCodeMap){
        this.evtLatest[code] =  {} ;
        for(const tid in this.tankMap){
          this.evtLatest[code][tid] = { dt: null, toasted:false }
        }
      }
    },

    async consoleAlarm(e){
      let cfg = this.alarmCfg.config;
      let tankCfg = this.alarmCfg.tank;

      try{
        if(!cfg.enabled) {
          // console.log('alarm disabled')
          return;
        }

        let tankAlarm = tankCfg[e.tid];

        if(!tankAlarm.enabled) {
          // console.log('tankAlarm disabled')
          return;
        }

        let isAlarm = cfg.events.find(evtCfg=>{
          return (evtCfg.code===e.code)? evtCfg.enabled:false
        });

        let isTankAlarm = tankAlarm.events.find(te=>{
          return (te.code===e.code)? te.enabled:false;
        });

        if(isAlarm){
          // TTS 출력
          if( isTankAlarm && cfg.console.tts && tankAlarm.console.tts) {
            speech(`${e.name}!`);
          }

          // 경보 목록 적재
          if(isTankAlarm && cfg.console.icon && tankAlarm.console.icon) {
            const last = this.evtLatest[e.code][e.tid];

            if( !last.toasted ){
              this.alerts.unshift( e );
              if(this.alerts.length>100) this.alerts.pop();

              this.evtLatest[e.code][e.tid] = { dt: e.dt, toasted: true };
            }

          }

          // 비프 사운드
          if(isTankAlarm && cfg.console.sound && tankAlarm.console.sound ) {
            if(['3', '6', '7'].includes(e.code) )
              await beepSound('danger');
            else
              await beepSound('warning');
          }
        }
      }catch(err){
        console.error(err);
      }finally{
        cfg = null;
        tankCfg = null;

      }
    },

    /**
     * 알람지연(억제) 여부
     * @param evtCode
     * @param tid
     * @returns {boolean}
     */
    isAlarmSuppressed( evtCode, tid ){
      const suppressedTank = this.suppressAlarms[evtCode];
      if(!suppressedTank) return false;

      const stopTo = suppressedTank[tid];
      if( stopTo ){
        if( moment(stopTo).isAfter() ) {
          return true;
        } else {
          this.$delete(suppressedTank, tid);
          return false;
        }
      }else{
        return false;
      }
    },


  },
  beforeDestroy(){
    // using "removeListener" here, but this should be whatever $socket provides
    // for removing listeners
    if(this.socket) this.socket.removeAllListeners('event', this.eventAlarmHandler );
    if(this.suppressInterval) clearInterval( this.suppressInterval );
  },
}
</script>
